<script>


import Layout from '@layouts/flight.vue'

import Fls from '@components/flight/FlsData.vue'
import SeatMapWrapper from '@components/flight/SeatMapWrapper.vue'

import Grid from '@components/grid.vue'



import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

import axios from 'axios'

import moment from 'moment'
import _ from 'underscore'

import { statusSummaryCellRenderer } from './../../components/grid/flightStatusCellRenderer.js'
import { getFlightConfig } from '@utils/helpers.js'

const reduceByKey = (data, key) =>
  _.reduce(
    data,
    function(memo, obj) {
      return memo + obj[key]
    },
    0
  )

const filterObj = {
  filter: 'agTextColumnFilter',
  filterParams: {
    applyButton: false,
    resetButton: true,
  },
  resizable: true,
  sortable: true,
}

const brdFormatter = function(params, type) {
  // formatters called from col def differs to if you call it
  // from the export CSV func. Check where data is located.
  const data = params.data || params.node.data
  if (data.PaxTotals && !data.PaxTotals.length) {
    return ' - '
  }
  return [
    reduceByKey(data.PaxTotals, 'BrdMale'),
    reduceByKey(data.PaxTotals, 'BrdFemale'),
    reduceByKey(data.PaxTotals, 'BrdChild'),
    reduceByKey(data.PaxTotals, 'BrdInfant'),
  ].join('/')
}

const bkdFormatter = function(params) {
  // formatters called from col def differs to if you call it
  // from the export CSV func. Check where data is located.
  const data = params.data || params.node.data
  if (data.PaxTotals && !data.PaxTotals.length) {
    return ' - '
  }
  return [
    reduceByKey(data.PaxTotals, 'ResFirst'),
    reduceByKey(data.PaxTotals, 'ResBusiness'),
    reduceByKey(data.PaxTotals, 'ResEconomy'),
  ].join('/')
}

const ckdFormatter = function(params) {
  // formatters called from col def differs to if you call it
  // from the export CSV func. Check where data is located.
  const data = params.data || params.node.data
  if (data.PaxTotals && !data.PaxTotals.length) {
    return ' - '
  }
  return [
    reduceByKey(data.PaxTotals, 'CkdFirst'),
    reduceByKey(data.PaxTotals, 'CkdBusiness'),
    reduceByKey(data.PaxTotals, 'CkdEconomy'),
  ].join('/')
}

const bkdMFCIFormatter = function(params) {
  // formatters called from col def differs to if you call it
  // from the export CSV func. Check where data is located.
  const data = params.data || params.node.data
  if (data.PaxTotals && !data.PaxTotals.length) {
    return ' - '
  }
  return [
    reduceByKey(data.PaxTotals, 'ResMale'),
    reduceByKey(data.PaxTotals, 'ResFemale'),
    reduceByKey(data.PaxTotals, 'ResChild'),
    reduceByKey(data.PaxTotals, 'ResInfant'),
  ].join('/')
}

const ckdMFCIFormatter = function(params) {
  // formatters called from col def differs to if you call it
  // from the export CSV func. Check where data is located.
  const data = params.data || params.node.data
  if (data.PaxTotals && !data.PaxTotals.length) {
    return ' - '
  }
  return [
    reduceByKey(data.PaxTotals, 'CkdMale'),
    reduceByKey(data.PaxTotals, 'CkdFemale'),
    reduceByKey(data.PaxTotals, 'CkdChild'),
    reduceByKey(data.PaxTotals, 'CkdInfant'),
  ].join('/')
}

const bagsFormatter = function(params) {
  // formatters called from col def differs to if you call it
  // from the export CSV func. Check where data is located.
  const data = params.data || params.node.data
  if (data.BagTotals && !data.BagTotals.length) {
    return ' - '
  }
  return [
    reduceByKey(data.BagTotals, 'TotalFirstPieces'),
    reduceByKey(data.BagTotals, 'TotalBusinessPieces'),
    reduceByKey(data.BagTotals, 'TotalEconomyPieces'),
  ].join('/')
}

const exportParams = {
  fileName: 'flightsExport.csv',
  suppressQuotes: false,
  columnSeparator: ',',
  processCellCallback: function(cellParams) {
    if (cellParams && cellParams.column.colId === 'StdDate') {
      return moment(cellParams.value).format('DDMMMYY')
    } else if (cellParams && cellParams.column.colId === 'Std') {
      return moment(cellParams.value).format('HH:mm') // apply your object formatter
    } else if (cellParams && cellParams.column.colId === 'BoardTime') {
      return cellParams.value ? moment(cellParams.value).format('HH:mm') : '-' // apply your object formatter
    } else if (cellParams && cellParams.column.colId === '0') {
      // Config
      return getFlightConfig(cellParams.node.data) // apply your object formatter
    } else if (cellParams && cellParams.column.colId === '1') {
      // Bkd
      return bkdFormatter(cellParams) // apply your object formatter
    } else if (cellParams && cellParams.column.colId === '2') {
      // Ckd
      return ckdFormatter(cellParams) // apply your object formatter
    } else if (cellParams && cellParams.column.colId === '3') {
      // bkdMFCI
      return bkdMFCIFormatter(cellParams) // apply your object formatter
    } else if (cellParams && cellParams.column.colId === '4') {
      // ckdMFCI
      return ckdMFCIFormatter(cellParams) // apply your object formatter
    } else if (cellParams && cellParams.column.colId === '5') {
      return brdFormatter(cellParams) // apply your object formatter
    } else if (cellParams && cellParams.column.colId === '6') {
      return bagsFormatter(cellParams) // apply your object formatter
    } else return cellParams.value // no formatting
  },
}

const columnDefs = [
  {
    field: 'FlightNumber',
    headerName: 'Flight',
    pinned: true,
    width: 60,
    ...filterObj,
  },
  {
    field: 'StdDate',
    headerName: 'Date',
    width: 55,
    pinned: true,
    valueFormatter: function(params) {
      return moment(params.value)
        .format('DDMMM')
        .toUpperCase()
    },
    ...filterObj,
  },
  {
    field: 'Std',
    headerName: 'STD',
    width: 75,
    pinned: true,
    valueFormatter: function(params) {
      return moment(params.value).format('HH:mm')
    },
    ...filterObj,
  },
  { field: 'Equipment', headerName: 'Type', ...filterObj },
  {
    headerName: 'Config',
    valueFormatter: function(params) {
      return getFlightConfig(params.data)
    },
    ...filterObj,
  },
  {
    headerName: 'Bkd Load Factor',
    width: 60,
    resizable: true,
    suppressSizeToFit: true,
    skipHeaderOnAutoSize: true,

    field: 'Std',
    cellRenderer: (params) => {
      console.log(params)
      const totalSeats =
        parseInt(params.data.SeatConfigFirst || 0) +
        parseInt(params.data.SeatConfigBusiness || 0) +
        parseInt(params.data.SeatConfigEconomy || 0)
      const totalBooked =
        reduceByKey(params.data.PaxTotals, 'ResFirst') +
        reduceByKey(params.data.PaxTotals, 'ResBusiness') +
        reduceByKey(params.data.PaxTotals, 'ResEconomy')
      const percent = (totalBooked / totalSeats) * 100
      const getClass = (percent) => {
        console.log(percent)
        switch (true) {
          case percent >= 0 && percent < 20:
            return 'low'
          case percent >= 20 && percent < 50:
            return 'med'
          case percent > 100:
            return 'over'
          default:
            return 'unknown'
        }
      }
      return `<div class="charts">
                <div class="chart chart--dev _tooltip">
                  <ul class="chart--horiz">
                    <li class="chart__bar ${getClass(
                      percent
                    )}" style="width: ${percent}%;" >
                      <div class="chart__label">
                       ${percent > 100 ? 'OVERBOOKED - ' : ''} ${Math.round(
        (totalBooked / totalSeats) * 100
      )}%
                      </div>
                    </li>
                  </ul>
                </div>
              </div>`
    },
  },
  { field: 'Registration', headerName: 'Reg' },
  { field: 'Destinations', headerName: 'Dest', width: 75, ...filterObj },
  {
    field: 'FlightStatus',
    cellRenderer: statusSummaryCellRenderer,
  },
  {
    headerName: 'Bkd [FCY]',
    valueFormatter: bkdFormatter,
    ...filterObj,
  },
  {
    headerName: 'Ckd [FCY]',
    valueFormatter: ckdFormatter,
    ...filterObj,
  },
  {
    headerName: 'Bkd [MFCI]',
    valueFormatter: bkdMFCIFormatter,
    ...filterObj,
  },
  {
    headerName: 'Ckd [MFCI]',
    valueFormatter: ckdMFCIFormatter,
    ...filterObj,
  },
  {
    headerName: 'Brd [FCY]',
    valueFormatter: brdFormatter,
    ...filterObj,
  },
  {
    headerName: 'Bags [FCY]',
    valueFormatter: bagsFormatter,
    ...filterObj,
  },
  { field: 'BoardGate', headerName: 'Gate', ...filterObj },
  {
    field: 'BoardTime',
    headerName: 'Board Time',

    valueFormatter: function(params) {
      return params.value ? moment(params.value).format('HH:mm') : ''
    },
    ...filterObj,
  },

  { field: 'OffblocksTime', headerName: 'ACT', width: 75, pinned: 'none' },
  { field: 'TakeoffTime', headerName: 'ADT', width: 75, pinned: 'none' },
  { field: 'Remarks', pinned: 'right' },
]
// Axios
const CancelToken = axios.CancelToken
let cancel

export default {
  page() {
    return {
      title: '',
      meta: [
        {
          name: 'description',
          content: ``,
        },
      ],
    }
  },
  components: {
    Layout,
    Grid,
    splitpanes: Splitpanes,
    pane: Pane,
    Fls,
    SeatMapWrapper,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sidePanelModel: {
        visible: false,
        activeComponent: null,
      },
      columnDefs: columnDefs,
      paxFilter: null,
      resizeHeaders: true,
      gridData: [],
      isLoading: false,
      lastUpdated: [{ type: 'flights', timestamp: null }],
      sideBarVisible: true,
      flightStatusStats: [
        { caption: 'Scheduled', state: false },
        { caption: 'Open', state: false },
        { caption: 'Closed', state: false },
        { caption: 'Finalized', state: false },
        { caption: 'Cancelled', state: false },
      ],
      params: { rollFlights: true, timeWindowFrom: -1440, timeWindowTo: 4320 },
      paramsSchema: [
        {
          fieldType: 'Checkbox',
          multi: false,
          value: null,
          name: 'rollFlights',
          label: 'Rolling Flights View',
        },
        {
          fieldType: 'TextInput',
          placeholder: 'e.g. -440',
          multi: false,
          value: null,
          name: 'timeWindowFrom',
          label: 'Time Window (From)',
        },
        {
          fieldType: 'TextInput',
          placeholder: 'e.g. 4320',
          multi: false,
          value: null,
          name: 'timeWindowTo',
          label: 'Time Window (To)',
        },
        // {
        //   fieldType: 'MultiSelect',
        //   placeholder: 'Select Carriers',
        //   multi: true,
        //   value: null,
        //   name: 'carrier',
        //   label: 'Carriers',
        // },
      ],
    }
  },
  computed: {
    selectedFlightId() {
      return this.$store.getters['flights/getSelectedFlightId']
    },
    flight() {
      if (!this.selectedFlightId) {
      }
      return this.$store.getters['flights/getFlightById'](this.selectedFlightId)
    },
    filterStatus() {
      const filters = this.flightStatusStats
        .filter((state) => state.state)
        .map((state) => {
          return state.caption.toUpperCase()
        })

      return filters
    },
    selectedFlightDate() {
      return this.$store.getters['flights/getSelectedFlightDate']
    },
    startDate() {
      return moment(this.selectedFlightDate.startDate).format('DDMMMYY')
    },
  },
  watch: {
    $route: {
      handler(route) {
        const thisPage = 'flights'
        if (route.name === thisPage) {
          //
          this.$refs.grid.autoSizeAll(this.resizeHeaders)
        }
      },
    },
    $resize: {
      immediate: true,
      handler(mq) {
        if (!this.$mq.above(992)) {
          this.columnDefs.forEach((col, index) => {
            if ('pinned' in col && index > 0) {
              col.pinned = false
            }
          })
          this.resizeHeaders = true
        } else {
          this.resizeHeaders = false
        }
      },
    },
    params: {
      deep: true,
      handler(params) {
        this.getData()
      },
    },
    flightStatusStats: {
      deep: true,
      handler() {
        this.getData()
      },
    },
    selectedFlightDate: {
      handler(date) {
        this.getData()
      },
    },
  },
  activated() {
    
    // this.$refs.grid.autoSizeAll()
  },
  timers: {
    getData: { time: 30000, autostart: true, repeat: true },
  },
  updated() {
    // this.$refs.grid.autoSizeAll(false)
  },
  mounted() {
    this.getData()
    setTimeout(() => {
      
this.initSlider();
    }, 500);
      
  },
  
  methods: {
    initSlider() {

      const slider = document.querySelectorAll('.card-box.row');
      
      let isDown = false
      let startX
      let scrollLeft

      slider.addEventListener('mousedown', (e) => {
        isDown = true
        slider.classList.add('active')
        startX = e.pageX - slider.offsetLeft
        scrollLeft = slider.scrollLeft
      })
      slider.addEventListener('mouseleave', () => {
        isDown = false
        slider.classList.remove('active')
      })
      slider.addEventListener('mouseup', () => {
        isDown = false
        slider.classList.remove('active')
      })
      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return
        e.preventDefault()
        const x = e.pageX - slider.offsetLeft
        const walk = (x - startX) * 3
        slider.scrollLeft = scrollLeft - walk
        console.log(walk)
      })
    },
    printGrid() {
      this.$refs.grid.onBtPrint()
    },
    csvExport() {
      this.$refs.grid.onBtnExport(exportParams)
    },
    onSelectionChanged(data) {
      console.log('data', data)
      if (data.length) {
        this.$store.dispatch('flights/SET_SELECTED_FLIGHT_ID', data[0].FlightId)
      } else {
        this.$store.dispatch('flights/SET_SELECTED_FLIGHT_ID', null)
      }
    },
    onCellDoubleClicked(data) {
      this.$store.dispatch('flights/SET_SELECTED_FLIGHT_ID', data[0].FlightId)
      this.openSeatMap2()
    },
    openPaxSummary() {
      this.$router.push(`/paxsummary/${this.selectedFlightId}`)
    },
    openSeatMap() {
      this.$router.push(`/seatmap2/${this.selectedFlightId}`)
    },
    openSeatMap2() {
      this.$router.push(`/seatmap2/${this.selectedFlightId}`)
    },
    getData() {
      this.isLoading = true

      if (cancel !== undefined) {
        cancel()
      }
      var uri
      if (this.params.rollFlights === true) {
        uri = `${this.$config.apiBaseUrl}flights/window/${this.params.timeWindowFrom},${this.params.timeWindowTo}`
      }
      if (this.params.rollFlights === false) {
        uri = `${this.$config.apiBaseUrl}flights/start/${this.startDate}/end/${this.startDate}`
      }
      axios
        .get(uri, {
          cancelToken: new CancelToken((c) => {
            cancel = c
          }),
        })
        .then((response) => {
          const data = response.data.Results[0]
          // filter flight status
          // Get an array of selected flight statuses
          const selectedFlightStatus = this.flightStatusStats.filter(
            (_status) => _status.state
          )
          // Map the caption (rather than the state)
          const flightStatusFilters = selectedFlightStatus.map((_status) => {
            return _status.caption.toUpperCase()
          })

          if (flightStatusFilters.indexOf('FINALIZED') > -1) {
            flightStatusFilters.push('DEPARTED')
          }
          // Process data
          if (flightStatusFilters.length) {
            console.log(flightStatusFilters)
            this.gridData = data.filter((_flight) => {
              const x = flightStatusFilters.indexOf(_flight.FlightStatus)
              if (x > -1) {
                return _flight
              }
            })
          } else {
            this.gridData = data
          }
          // this.gridData = data
          this.lastUpdated[0].timestamp = response.data.Timestamp
          this.$store.dispatch('flights/SET_FLIGHTS', data)
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          cancel()
          this.isLoading = false
          // setTimeout(() => this.$refs.grid.autoSizeAll(true), 0)
        })
    },
  },
}
</script>

<template>
  <Layout
    id="fltList5465"
    :last-updated="lastUpdated"
    :params="params"
    :params-schema="paramsSchema"
  >

    <div class="content-container">
      <div class="chat-module" data-filter-list="chat-module-body">
        <div class="toolbar row p-2">
          <!-- v-if="$resize && $mq.above(992)" -->
          <div class="col-md-2">
            <input
              v-model="paxFilter"
              class="form-control form-control-sm"
              type="text"
              placeholder="Flights Search (All Columns)"
            />
          </div>

          <div class="col-md-7">
            <button
              class="btn btn-sm btn-dark btn-refresh mr-2"
              :disabled="isLoading"
              @click="getData"
              >{{ isLoading ? 'Refreshing...' : 'Refresh' }}</button
            >

            <b-button-group size="sm" class="mr-2">
              <b-button
                v-for="(btn, idx) in flightStatusStats"
                :key="idx"
                :pressed.sync="btn.state"
                variant="dark"
              >
                <div class="on" :class="btn.state ? 'active' : ''"></div>
                {{ btn.caption }}
              </b-button>
            </b-button-group>

            <b-dropdown
              v-if="$resize && $mq.above(992)"
              text="Export"
              variant="dark"
              size="sm"
              class
            >
              <b-dropdown-item :disabled="isLoading" @click="printGrid">
                <b-icon icon="document-richtext" class="mr-1"></b-icon>Print
                Flights
              </b-dropdown-item>
              <b-dropdown-item :disabled="isLoading" @click="csvExport">
                <b-icon icon="cloud-download" class="mr-1"></b-icon>Download CSV
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="col-md-3 text-right">
            <button
              class="btn btn-sm btn-dark ml-1"
              :disabled="isLoading || !selectedFlightId"
              @click="openSeatMap"
              >Seatmap</button
            >
            <button
              class="btn btn-sm btn-dark ml-1"
              :disabled="isLoading || !selectedFlightId"
              @click="openPaxSummary"
              >Pax Summary</button
            >
            <button
              class="btn btn-sm btn-dark ml-1"
              :disabled="isLoading || !selectedFlightId"
              @click="
                sidePanelModel.visible = !sidePanelModel.visible
                sidePanelModel.activeComponent = 'Fls'
              "
            >
              <b-icon v-if="!sidePanelModel.visible" icon="arrow-left"></b-icon>
              <b-icon v-if="sidePanelModel.visible" icon="arrow-right"></b-icon>
            </button>
          </div>
        </div>

        <splitpanes class="default-theme">
          <pane :min-size="$resize && $mq.above(1440) ? 75 : 70">
            <Grid
              v-if="gridData"
              ref="grid"
              :resize-headers="resizeHeaders"
              :column-defs="columnDefs"
              :quick-filter="paxFilter"
              filter-col="FlightStatus"
              :grid-data="gridData"
              id-key="FlightId"
              @onSelectionChanged="onSelectionChanged"
              @onCellDoubleClicked="onCellDoubleClicked"
            />
          </pane>
          <pane
            v-if="sidePanelModel.visible"
            min-size="0"
            :max-size="$resize && $mq.above(1440) ? 25 : 30"
          >
            <div class="px-4">
              <ul class="nav nav-tabs nav-justified mt-1" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link small"
                    :class="
                      sidePanelModel.activeComponent === 'Fls' ? 'active' : ''
                    "
                    data-toggle="tab"
                    role="tab"
                    aria-selected="sidePanelModel.activeComponent === 'Fls'"
                    @click="sidePanelModel.activeComponent = 'Fls'"
                    >Pax Summary</a
                  >
                </li>

                <li class="nav-item">
                  <a
                    class="nav-link"
                    :class="
                      sidePanelModel.activeComponent === 'SeatMapWrapper'
                        ? 'active'
                        : ''
                    "
                    data-toggle="tab"
                    role="tab"
                    aria-selected="sidePanelModel.activeComponent === 'SeatMapWrapper'"
                    @click="sidePanelModel.activeComponent = 'SeatMapWrapper'"
                    >Seat Map</a
                  >
                </li>
              </ul>
              <div class="scrollable">
                <component
                  :is="sidePanelModel.activeComponent"
                  v-if="flight"
                  :flight="flight"
                  class="mt-2"
                  :scale="true"
                />
              </div>
            </div>
          </pane>
        </splitpanes>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
.toolbar {
  background: #f5f7f7;
}
.totals-row {
  display: flex;
  justify-content: space-evenly;
}
hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.flight-status.FINALIZED {
  background: #1c2b36;
  padding: 1px 5px;
  border-radius: 2px;
  color: white;
}

.text-lg {
  font-size: 1.2rem;
}

.carrier-tag {
  padding: 1px 9px;
  border-radius: 3px;
  color: #fff;
}

.splitpanes.default-theme .splitpanes__pane {
  background-color: #f5f7f7;
}
.splitpanes.default-theme .splitpanes__pane {
  background: linear-gradient(
    180deg,
    rgb(245, 247, 247) 0%,
    rgba(255, 255, 255, 0.9) 4%
  );
}

.scroll-panel {
  height: 88%;
  overflow-y: auto;
}

.scrollable {
  height: calc(100vh - 201px);
  overflow-x: auto;
  padding-right: 1rem;
}

.nav-tabs {
  border-radius: 0.5rem;
  background: #e9ecef;
  box-shadow: 1px 1px 3px 2px #fefefe;
  z-index: 9;
  position: relative;
}

.on {
  width: 10px;
  height: 10px;
  display: inline-block;

  border-radius: 50%;
  background: gray;
  position: relative;
  bottom: -0.05em;
  &.active {
    background: #8bc34a;
    background: radial-gradient(#cddc39, #8bc34a);
  }
}
</style>
